import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import Dialogs from '../../../hooks/Dialogs';
import { useConfiguration } from '../../../hooks/Configuration';
import Window from '../Window';
import Dialogger from '../Dialogger';
import { ALERT_INTERRUPTED, EXPANDED_STORAGE_KEY, FORCE_EXPANDED_STORAGE_KEY, MOBILE_WIDTH } from '../../../constants/global';
import { ConfigurationFeaturesCloseModeEnum } from '../../../api/models';
import Alert from '../../atoms/Alert';

export const saveOpen = () => localStorage.setItem(EXPANDED_STORAGE_KEY, 'true');
export const saveClose = () => localStorage.setItem(EXPANDED_STORAGE_KEY, 'false');

const getInitState = (defaultState: boolean, withMemo: boolean): boolean => {
    if (window.innerWidth <= MOBILE_WIDTH) return false;

    //vynuceni, ze se pri incializaci ma otevrit chatbot
    if (sessionStorage.getItem(FORCE_EXPANDED_STORAGE_KEY) === 'true') {
        sessionStorage.removeItem(FORCE_EXPANDED_STORAGE_KEY);
        return true;
    }

    //pri nepouzivani pameti stavu otevreni se vzdy vrati vychozi stav
    if (!withMemo) return defaultState;

    const memo = localStorage.getItem(EXPANDED_STORAGE_KEY);

    //pokud je ulozeny stav, vrati se ten. Pokud ne, tak se vrati vychozi stav
    if (memo === (!defaultState).toString()) return !defaultState;
    return defaultState;
};

let timeout: any;

function Chatbot() {
    const configuration = useConfiguration();
    const [open, setOpen] = useState<boolean>(getInitState(
        !!configuration?.features.defaultOpen,
        !!configuration?.features.memoOpen
    ));
    const [showAlert, setShowAlert] = useState(false);

    useEffect(
        () => {
            if (sessionStorage.getItem(ALERT_INTERRUPTED)) return;
            if (!configuration?.features.alertTimer) return;

            timeout = setTimeout(
                () => !open && setShowAlert(true),
                configuration.features.alertTimer * 1000
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const toggleVisible = useCallback(
        () => {
            const out = !open;
            setOpen(out);

            if (out) {
                timeout && clearTimeout(timeout);
                sessionStorage.setItem(ALERT_INTERRUPTED, true.toString());
                setShowAlert(false);
            }

            out ? saveOpen() : saveClose();
        },
        [open]
    );

    return (
        <div
            id='stx-chat-wrapper'
            className={configuration?.design}>
            <Dialogs>
                {
                    showAlert &&
                    <Alert />
                }
                <Window open={open} />

                {
                    open &&
                    configuration?.features.closeMode === ConfigurationFeaturesCloseModeEnum.X &&
                    <div
                        id='stx-chat-close'
                        className='desktop-only'
                        title={configuration?.texts.btnCloseTitle}
                        onClick={toggleVisible}>
                        <FontAwesomeIcon
                            icon={icon({ name: 'xmark' })}
                            size='sm' />
                    </div>
                }
                {
                    open &&
                    <div
                        id='stx-chat-close'
                        className='mobile-only'
                        title={configuration?.texts.btnCloseTitle}
                        onClick={toggleVisible}>
                        <FontAwesomeIcon
                            icon={icon({ name: 'xmark' })}
                            size='lg' />
                    </div>
                }
                {
                    (
                        configuration?.features.closeMode === ConfigurationFeaturesCloseModeEnum.Expander ||
                        !open
                    ) &&
                    <div
                        id='stx-chat-expander'
                        title={open ? configuration?.texts.btnCloseTitle : configuration?.texts.btnExpandTitle}
                        style={{
                            backgroundColor: configuration?.styles.iconBgColor,
                            backgroundImage: `url(${configuration?.mediaPath}${configuration?.styles.iconImage})`
                        }}
                        onClick={toggleVisible} />
                }

                <Dialogger />
            </Dialogs>
        </div>
    );
}

export default Chatbot;
